<script lang="ts">import { browser } from "$app/environment";
const prodHosts = ["flush.com", "www.flush.com"];
const showSeal = browser && prodHosts.includes(window.location.hostname);
const inLine = false;
</script>

{#if showSeal}
	{#if inLine}
		<div
			id="anj-206721e8-853c-4a05-b890-4c86015bd5d9"
			data-anj-seal-id="206721e8-853c-4a05-b890-4c86015bd5d9"
			data-anj-image-size="32"
			data-anj-image-type="basic-x-small"
		></div>
		<script
		
			src="https://206721e8-853c-4a05-b890-4c86015bd5d9.snippet.anjcdn.org/anj-seal.js"
		></script>
	{:else}
		<iframe title="Seal" src="/seal.htm" style="height: 50px; width: 45px;"></iframe>
	{/if}
{/if}
